import { convertFromRaw, RawDraftContentState } from "draft-js";
import moment from "moment-timezone";

const isEmpty = field =>
  JSON.stringify(field) === "" ||
  field === null ||
  field === "" ||
  field === undefined;

const isEmptyWriteup = (writeup: unknown): boolean => {
  if (isEmpty(writeup) || writeup === "null") {
    return true;
  }

  try {
    const raw = typeof writeup === "string" ? JSON.parse(writeup) : writeup;

    if (!raw || typeof raw !== "object") {
      return true;
    }

    return !convertFromRaw(raw as RawDraftContentState)
      .getPlainText()
      .trim();
  } catch {
    return true;
  }
};

const validateRequiredField = data => {
  if (isEmpty(data)) {
    return "This field is required.";
  }

  return null;
};

export const couponCollectionDraftValidation = initialForm => {
  const { title } = initialForm;

  const collectionTitleMessage = () => {
    if (isEmpty(title)) {
      return "This field is required.";
    }
    return null;
  };

  return {
    title: collectionTitleMessage()
  };
};

export const couponCollectionPublishValidation = initialForm => {
  const {
    title,
    categories,
    classification,
    writeup,
    startDate,
    startTime,
    endDate,
    endTime,
    bannerImage
  } = initialForm;

  const imageMessage = () => {
    if (isEmpty(bannerImage)) {
      return "Collection Banner Image must be provided. ";
    }
    return null;
  };

  const collectionTitleMessage = () => {
    if (isEmpty(title)) {
      return "This field is required.";
    }
    return null;
  };

  const categoriesMessage = () => {
    if (isEmpty(categories)) {
      return "This field is required.";
    }
    return null;
  };

  const endDateMessage = () => {
    if (isEmpty(endDate)) {
      return "This field is required.";
    }
    if (startDate && endDate < startDate) {
      return "Coupon end date should be greater than or equal to start date.";
    }
    return null;
  };

  const endTimeMessage = () => {
    const hasStartValues = !!startDate && !!startTime;
    if (isEmpty(endTime)) {
      return "This field is required.";
    }
    if (hasStartValues && !!endDate) {
      const startMoment = moment(
        startDate + " " + startTime,
        "YYYY-MM-DD HH:mm"
      );
      const endMoment = moment(endDate + " " + endTime, "YYYY-MM-DD HH:mm");
      const isPast = endMoment.isBefore(startMoment.add(1, "minutes"));

      if (isPast) {
        return "Coupon collection end time and date should be after start date and time.";
      }
    }
    return null;
  };

  const validateWriteUp = () => {
    if (isEmptyWriteup(writeup)) {
      return "This field is required.";
    }
    return null;
  };

  return {
    categories: categoriesMessage(),
    classification: validateRequiredField(classification),
    writeup: validateWriteUp(),
    endDate: endDateMessage(),
    endTime: endTimeMessage(),
    bannerImage: imageMessage(),
    startDate: validateRequiredField(startDate),
    startTime: validateRequiredField(startTime),
    title: collectionTitleMessage()
  };
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};

export interface CouponCollectionErrorForm {
  title: string;
  categories?: string;
  classification?: string;
  writeup?: string;
  startDate?: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
  bannerImage?: string;
}

export interface CouponCollectionFormData {
  bannerImage: string;
  title: string;
  status: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  categories: string[];
  id: string;
  classification: string;
  writeup: RawDraftContentState;
  isHidden: boolean;
  isFeatured: boolean;
  collectionType: string;
  slug?: string;
}
